import React from 'react'
import "./bussiness.scss";
import { motion } from "framer-motion";
import Navbar from '../landing/header/Navbar';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Workflows from '../landing/workflows/Workflows';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Industries from '../landing/Industries/Industries';
import Headernew from '../landing/headernew/Headernew';
import ScheduleButton from '../landing/main-banner/ScheduleButton';
const Bussiness = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const cardVariants = {
        hidden: { opacity: 0, y: 40 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" },
        },
    };

    const options = {
        margin: window.innerWidth > 600 ? 20 : 10,
        loop: true,
        autoplay: window.innerWidth > 600 ? true : false,
        autoplayTimeout: window.innerWidth > 600 ? 2000 : null,
        autoplayHoverPause: window.innerWidth > 600 ? true : false,
        smartSpeed: 600,
        autoplaySpeed: 600,
        nav: true,
        dots: false,
        navText: [
            "<img src='/assets/left.svg'/>",
            "<img src='/assets/right.svg'/>",
        ],
        responsive: {
            0: { items: 1 },
            300: { items: 1.1 },
            400: { items: 1.1 },
            600: { items: 1.1 },
            1000: { items: 2.5 },
            1300: { items: 3.5 },
            1700: { items: 4.5 },
        },
    };

    const testimonials = [
        {
            name: "Financial Reporting & Analysis",
            quote:
                "Prepare accurate statements under IFRS & GAAP for internal and external reporting.",
            img: "/assets/doone.svg",
        },
        {
            name: "A/P & A/R Management",
            quote:
                "Manage ageing schedules, balances, and timely settlements for strong liquidity.",
            img: "/assets/dotwo.svg",
        },
        {
            name: "Day-to-Day Bookkeeping",
            quote:
                "Systematically record transactions to reflect true financial position of the business.",
            img: "/assets/dothree.svg",
        },
        {
            name: "Payroll Processing",
            quote:
                "Compute gross-to-net, apply deductions, and prepare journals across countries.",
            img: "/assets/dofour.svg",
        },




        {
            name: "Intercompany Reconciliation",
            quote:
                "Reconcile balances & prepare consolidated statements for accurate group reporting.",
            img: "/assets/doone.svg",
        },
        {
            name: "Month-End Closing & Journals",
            quote:
                "Handle accruals, prepayments, depreciation, and adjustments for a fair monthly view.",
            img: "/assets/dotwo.svg",
        },
        {
            name: "Audit Prep & Controls",
            quote:
                "Compile audit-ready data & set up internal controls that uphold financial integrity.",
            img: "/assets/dothree.svg",
        },
        {
            name: "Subsidiary & Consolidated Reports",
            quote:
                "Maintain subsidiary books & eliminate intercompany transactions under IFRS or GAAP.",
            img: "/assets/dofour.svg",
        },
    ];

    const cardsData = [
        {
            title: "8+ years of proven experience with U.S. and global clients",
            desc: "Stay ahead of threats with ongoing assessments and monitoring, ensuring your defenses remain robust against new vulnerabilities.",
            img: "/assets/paone.svg",
        },
        {
            title: "Deep IFRS & GAAP knowledge",
            desc: "Leverage our team's expertise to gain deep insights into your security strengths and weaknesses, empowering you to make informed decisions.",
            img: "/assets/patwo.svg",
        },
        {
            title: "Trusted by tech firms, startups, and service providers",
            desc: "Our proactive approach ensures that potential security issues are identified and addressed before they can impact your operations.",
            img: "/assets/pathree.svg",
        },
        {
            title: "Reliable delivery with clear communication",
            desc: "Enjoy the peace of mind that comes from knowing your organization is continuously protected by leading security experts.",
            img: "/assets/pafour.svg",
        },
        {
            title: "No outsourcing — 100% dedicated in-house team",
            desc: "Our subscription model offers a cost-effective solution to obtaining top-tier security assessments, saving you the expense of in-house resources or one-off consultations.",
            img: "/assets/pafive.svg",
        },
        {
            title: "Scalable support for startups or expanding enterprises",
            desc: "Our proactive approach ensures that potential security issues are identified and addressed before they can impact your operations.",
            img: "/assets/pathree.svg",
        },
    ];


    return (
        <>
            <section className="main-banner security_main">
                <Headernew />
                <video
                    className="main-banner-video"
                    muted
                    playsInline
                    autoPlay
                    loop
                    width="100%"
                    id="myVideo"
                >
                    <source src="/assets/bannervideo.mp4" type="video/mp4" />
                </video>

                <div className="custom-container1">
                    <div className="top_banner">
                        <motion.h3
                            initial={{ x: -100, opacity: 0 }}
                            whileInView={{ x: 0, opacity: 1 }}
                            viewport={{ once: false }} // 👈 animation runs every time on scroll
                            transition={{ duration: 1 }}
                        >
                            Accountant on Demand
                        </motion.h3>


                    </div>
                    <motion.h4
                        initial={{ x: -100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        viewport={{ once: false }} // 👈 animation runs every time on scroll
                        transition={{ duration: 1 }}
                    >
                        <div className='elevate_mains lastauses'>
                            <p>Reliable Accounting Support, When You Need It Most
                                We provide professional, fully remote accounting services tailored to your business.
                                Accurate financial records, timely reporting, and full compliance with local & international standards -
                                so you can focus on growth while we handle the numbers.
                            </p>


                        </div>
                    </motion.h4>


                </div>
            </section>
            <div className='marque_div'>
                <h3>Trusted By Clients Across Industries</h3>
                <div className="trendinganimations">
                    <div className="trendinganimationsright">
                        <div className="marquee">
                            <div className="marquee__group">
                                <div>
                                    <img className='imgunder' src="\assets\1.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\2.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\3.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\4.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\5.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\6.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\7.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\8.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\9.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\10.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\1.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\2.png" />
                                </div>

                                <div>
                                    <img className='imgunder' src="\assets\11.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\12.png" />
                                </div>






                            </div>
                            <div aria-hidden="true" className="marquee__group">
                                <div>
                                    <img className='imgunder' src="\assets\1.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\2.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\3.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\4.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\5.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\6.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\7.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\8.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\9.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\10.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\1.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\2.png" />
                                </div>

                                <div>
                                    <img className='imgunder' src="\assets\11.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\12.png" />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='nnew_cardfss'>
                <div className='custom-container1'>

                    <div className='challenge'>
                        <h5> Common Challenges We Solve</h5>
                        <div className='eight_cards1112'>
                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>  Inaccurate or Disorganized Books</h6>
                                <p>We clean up and maintain accurate records to ensure financial clarity and confidence.</p>
                            </div>
                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Delays in Reporting & Compliance</h6>
                                <p>Prompt weekly, monthly, and quarterly reports keep you ahead of deadlines and regulations.</p>
                            </div>
                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6> Cash Flow Uncertainty</h6>
                                <p>We monitor, forecast, and manage cash flow so you can make smarter decisions.</p>
                            </div>

                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Compliance Risk</h6>
                                <p>With IFRS, GAAP, and regional tax expertise, we keep you audit-ready and compliant.</p>
                            </div>
{/*
                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Lorem, ipsum.</h6>
                                <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eos culpa nulla  molestiae.</p>
                            </div>

                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Lorem, ipsum.</h6>
                                <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eos culpa nulla  molestiae.</p>
                            </div> */}

                        </div>
                    </div>

                </div>

            </div>
            <section className="slider_Div lassst_div">
                <h5>Accounting Solutions</h5>
                <div className="cardshead">
                    <OwlCarousel className="owl-theme" {...options}>
                        {testimonials.map((t, i) => (
                            <motion.div
                                key={i}
                                className="cards"
                                variants={cardVariants}
                                initial="visible"
                                whileInView="visible"
                                viewport={{ once: false, amount: 0.4 }} // replay on every scroll‑in
                            >
                                <img className="imgggg" src={t.img} alt={t.name} />                <h2>{t.name}</h2>
                                <h3>{t.title}</h3>
                                <p>“{t.quote}”</p>
                            </motion.div>
                        ))}
                    </OwlCarousel>
                </div>
            </section>

            <section className='secure_main1'>
                <img src='/assets/elipses.png' className='elipses' alt='background design' />
                <div className='custom-container1'>
                    <div className='inner_secure'>
                        <h3>Why Work With Us?
                        </h3>
                        <div className='parent_four_cards'>
                            {cardsData.map((card, index) => (
                                <motion.div
                                    className='onne_card'
                                    key={index}
                                    custom={index}
                                    variants={cardVariants}
                                    initial='hidden'
                                    whileInView='visible'
                                    viewport={{ once: false, amount: 0.3 }} // triggers on scroll in & out
                                >
                                    <div>
                                        <h4>{card.title}</h4>
                                        {/* <p>{card.desc}</p> */}
                                    </div>
                                    <img src={card.img} alt={card.title} />
                                </motion.div>
                            ))}
                        </div>

                    </div>
                </div>
                {/* <p className='textdiv'>At TechSecure360, we are committed to helping organizations meet regulatory compliance requirements, strengthen their security measures, and effectively respond to security incidents. Contact us today to ensure your organization's security and regulatory needs are met with excellence.</p> */}
            </section>



            {/* <div className='sub_mains'>
                <div className='custom-container1'>
                    <h3>Security Assessment Subscriptions</h3>

                    <div className='two_cardsmains'>
                        <div className='leftsidecards'>
                            <img src='\assets\shadee.png' className='shadeneww' />
                            <h4>Compliance Starter</h4>
                            <h5>$799/Month</h5>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Basic Compliance Assessment & Gap Analysis
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Standard Policy Development & Implementation Support

                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Annual Security Audit Against Industry Standards
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Customized Security Awareness Training (Annually)
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Basic Incident Response Planning
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Quarterly Compliance Monitoring & Updates
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Email Support for Compliance Queries
                            </h6>
                            <button className='bluebutton'>Contact Us</button>

                        </div>

                        <div className='rightsidecards'>
                            <h4>Pro Package</h4>
                            <h5>$1399/Month</h5>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Comprehensive Compliance Assessment & Gap Analysis


                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Advanced Policy Development & Implementation

                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Detailed Security Audits Against Industry Standards (Semi-annually)
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Customized Security Awareness Training (Semi-annually)
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Strategic Incident Response Planning

                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Continuous Compliance Monitoring & Updates
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Dedicated Support for Compliance Queries (Direct Access)
                            </h6>
                            <button className='whitebutton'>Contact Us</button>
                        </div>
                    </div>
                </div>

            </div> */}
            <section className='work_main'>
                {/* Background Shade Image */}
                <motion.img
                    src='/assets/shade.png'
                    className='imggshade'
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 1 }}
                    viewport={{ once: false }}
                    alt='background shade'
                />

                {/* Background Video */}
                <motion.video
                    className='main-banner-video'
                    muted
                    playsInline
                    autoPlay
                    loop
                    width="100%"
                    id="myVideo"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 1.2 }}
                    viewport={{ once: false }}
                >
                    <source src="/assets/bottomvideo.mp4" type="video/mp4" />
                </motion.video>

                <div className='custom-container1'>
                    <motion.div
                        className='inner_work'
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: false }}
                    >
                        <h2>Let’s Strengthen Your Finance Function</h2>

                        <motion.p
                            className='pppptags'
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.2, duration: 0.6 }}
                            viewport={{ once: false }}
                        >
                            Whether you need ongoing bookkeeping, clean financial reporting, or a dedicated accounting partner,
                            our team is here to support your success.
                        </motion.p>

                        <motion.div
                            className='buttons_div'
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.4, duration: 0.6 }}
                            viewport={{ once: false }}
                        >
                           <ScheduleButton />
                            {/* <button className='two'>Explore Portfolio</button> */}
                        </motion.div>
                    </motion.div>
                </div>
            </section>

        </>
    )
}

export default Bussiness





